import React, { useState } from 'react';
import { exportConfigurationTemplate } from './exportConfigurationTemplate';
import TreeView from './TreeView';
import act from '@flux/actions/actView';
import { Tooltip } from '@components/Outputs';
import { Button, Icon } from '@ts/storybook';
import { withTranslation } from 'react-i18next';

const checkAndDisableSubEntities = (node, nodeKey, disableEntityKey) => {
  if (node && nodeKey === disableEntityKey) node.exportValue = false;
  if (node && (node.children || node.configSection)) {
    const children = node.configSection || node.children;
    Object.keys(children).forEach(childKey => checkAndDisableSubEntities(children[childKey], childKey, disableEntityKey));
  }
};

const checkAndEnableConfigSections = (newConfig, configNode) => {
  const children = configNode.configSection || configNode.children;
  Object.keys(children).map(childKey => {
    const child = children[childKey];
    if (child.exportValue) {
      if (newConfig[childKey]) {
        newConfig[childKey].exportValue = true;
      }
      if (child.configSection || child.children) {
        checkAndEnableConfigSections(newConfig, child);
      }
    }
  });
};

const ImportExport = ({ t }) => {
  const [configTemplate, setConfigTemplate] = useState(exportConfigurationTemplate);

  const getDisabledRootEntities = () => {
    const disabledRootEntities = {};
    Object.keys(configTemplate).forEach(nodeKey =>
      lockRootEntities(configTemplate[nodeKey], nodeKey, nodeKey, disabledRootEntities)
    );
    return disabledRootEntities;
  };

  const lockRootEntities = (node, nodeKey, prevNodeKey, disabledRootEntities) => {
    if (nodeKey !== prevNodeKey && node.exportValue && configTemplate[nodeKey]) disabledRootEntities[nodeKey] = true;
    if (node && node.exportValue && (node.children || node.configSection)) {
      const children = node.configSection || node.children;
      Object.keys(children).forEach(childKey => lockRootEntities(children[childKey], childKey, nodeKey, disabledRootEntities));
    }
  };

  const onChange = config => value => {
    const checked = value.target.checked;
    const newConfig = { ...configTemplate };
    const pathChunks = config.split('.');
    const pathLength = pathChunks.length;
    let configNode = newConfig[pathChunks[0]];
    for (let i = 1; i < pathLength; i++) {
      const tree = configNode.configSection || configNode.children;
      configNode = tree[pathChunks[i]];
    }
    configNode.exportValue = checked;
    if (pathLength === 1 && !checked) {
      // Disable same entity on nested levels
      Object.keys(configTemplate).forEach(nodeKey => checkAndDisableSubEntities(newConfig[nodeKey], nodeKey, config));
    } else if (pathLength > 1 && checked && newConfig[pathChunks[pathLength - 1]]) {
      // Check nested entity, enable same entity of first level
      newConfig[pathChunks[pathLength - 1]].exportValue = true;
    }
    // If a whole new section checked, check nested values
    if ((configNode.configSection || configNode.children) && checked) {
      checkAndEnableConfigSections(newConfig, configNode);
    }
    setConfigTemplate(newConfig);
  };

  const onSend = () => {
    const url = '/api/exportConfiguration';
    act.push({ url, data: { exportConfiguration: configTemplate } });
    act.notify({ msg: t('Exporting configuration') + '...' });
  };

  const disabledRootEntities = getDisabledRootEntities();
  return (
    <div style={styles.container}>
      <span style={styles.title}>
        {t('Export configuration data')}
        <Tooltip
          title={
            t('Checking nested entities will enable base entities needed') +
            '</br>' +
            t('Disabling base entities will disable nested entities of the same type')
          }
        >
          <Icon icon={'action-info'} style={styles.info} />
        </Tooltip>
      </span>
      <TreeView configTemplate={configTemplate} onChange={onChange} disabledRootEntities={disabledRootEntities} />
      <Button onClick={onSend} variant="contained" type="submit" style={styles.button} label="Export config" />
    </div>
  );
};

const styles = {
  container: { margin: 15 },
  title: {
    fontSize: 24,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
  },
  button: { marginTop: 10 },
  info: { marginLeft: 10 },
};

export default withTranslation()(ImportExport);
